/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"

class ProductsPerPage extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="products--perPage">
        Products Per Page
        <ul>
          {this.props.per_page_options.map((option, index) => {
            return (
              <li key={index}>
                <a
                  href="#"
                  className={this.props.per_page === option ? 'selected' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.setPerPage(option);
                  }}>
                  {option}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default ProductsPerPage;
